export const getRotation = (index: number) => {
  return index * 3 * (index % 2 ? -1 : 1);
};
